import APIRequestState from '../_util/api-request';

class UserInviteState extends APIRequestState {
  get url() { return '/me/referral/invites'; }
  get method() { return 'GET'; }
  get singular() { return 'userInvite'; }
  get plural() { return 'userInvites'; }
}

export default UserInviteState;



// WEBPACK FOOTER //
// ./spa/state/user/user-referral-invites.jsx